module.exports = __webpack_public_path__ + "37b7127700709d91ce11164d694146cf.svg";